import { CabecalhoSecao } from './CabecalhoSecao';
import { ListaPassos, Passo } from './Passo';
import base from './publico.module.css';

export function ComoFunciona() {
  return (
    <section id="como-funciona" className={base.secao}>
      <div className={base.conteudo}>
        <CabecalhoSecao sobretitulo="Como funciona" titulo="Do SPED ao ZIP, em três passos">
          Sem configurar nada: crie a conta, traga as notas e acompanhe o lote
          pelo painel.
        </CabecalhoSecao>
        <ListaPassos>
          <Passo
            numero="1"
            titulo="Envie o SPED — ou as chaves"
            texto="Mande a pasta do ano inteiro (ou um .zip) e extraímos as chaves de todas as notas. Prefere a lista pronta? Cole ou envie um CSV: lemos as sequências de 44 dígitos de qualquer coluna e descartamos as repetidas."
          />
          <Passo
            numero="2"
            titulo="Filtre o que interessa"
            texto="Competência, CFOP, entrada ou saída, modelo, situação, participante. As contagens acompanham a seleção, então você vê quantas notas — e quanto custa — antes de começar."
          />
          <Passo
            numero="3"
            titulo="Baixe o ZIP"
            texto="A busca roda em segundo plano, com retentativa por chave — pode fechar a aba, e ela retoma de onde parou se o serviço reiniciar. Dá para baixar o parcial a qualquer momento."
          />
        </ListaPassos>
      </div>
    </section>
  );
}
